import { render } from "./SendHistComponent.vue?vue&type=template&id=47c4d557"
import script from "./SendHistComponent.vue?vue&type=script&lang=js"
export * from "./SendHistComponent.vue?vue&type=script&lang=js"

import "./SendHistComponent.vue?vue&type=style&index=0&id=47c4d557&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__